import jquery from 'jquery';

function resolveElement(elem: any): Element | null {
  if (elem == null) {
    return null;
  }
  if (elem.nodeType === 1) {
    return elem as Element;
  }
  if (typeof elem.length === 'number' && elem.length === 0) {
    return null;
  }

  const el = jquery(elem).get(0);

  return el || null;
}

export default (elem: any) => {
  const el = resolveElement(elem);

  if (!el) {
    return;
  }

  const rect = el.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};
